export const errorDialog = (function () {
  const error = ({ title = null } = {}) => {
    if (!title) return;

    bootbox
      .dialog({
        title: '<i class="fal fa-exclamation-triangle text-danger mr-2"></i> ' + $lang.artwork.Warning,
        message: title,
        buttons: {
          Ok: {
            label: $lang.btn.ok,
            className: 'btn btn-danger',
          }
        }
      });
  };

  return {
    error
  };
})();
